import { Component, OnInit, EventEmitter, OnDestroy, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { DCInput } from "./includes/dynamic_components/dynamic.service";
import { DialogService } from './includes/dynamic_components/dialog/dialog.service';
import { Channel, ChannelsGroup } from './includes/IPTV_Editor/iptv_editor.component';
import { ChannelsBundle } from './app.component';

@Component({
    selector: 'text-editor',
    template: `<dialog-window [title]="title" (close)="close()" [full-height]="true">
                <div tabindex="1" id="TextEditorContainer">
                    <textarea tabindex="-1" style="" [(ngModel)]="playlist"></textarea>
                    <div class="drop-background"  (drop)="drop($event)" (dragover)="dragover($event)" >
                    <span>&#xf102;</span><br>
                    Бросай</div>   
                </div>

                <div dialog-footer class="handler-buttons">
                    <button tabindex="1" #applyButton (click)="save()" class="blue-button" title="Использовать данный плейлист">Применить</button> &nbsp;
                    <button tabindex="1" *ngIf="showJoinButton" (click)="join()" class="blue-button" title="Добавить новые каналы из данного плейлиста">Объеденить</button>
                </div>
                </dialog-window>
    `,
    styles: [`
    #TextEditorContainer {
        position: relative;
        height: calc(100vh - 68px);
        width: calc(100vw - 20vw);
        display: table;
    }
    #TextEditorContainer.drop-hover textarea {
        display: none;
    }
    .drop-background{
        background: white;
        color: #296fac;
        font-size: calc(6vw + 6vh + 2vmin);
        text-align:center;
        line-height: 70%;
        vertical-align: middle;
        border: 3px dashed #ccc;
        display: none;
        height: 100%;
        width: 100%;
    }
    .drop-background span {
        font-family: "Ionicons";
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
    }
    .drop-hover .drop-background {
        display: table-cell;
    }
    textarea {
        white-space: pre;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        position: absolute; /** Для совместимости с FF. */
    }

    @media (max-width: 700px) {
        #TextEditorContainer {
            width: calc(100vw - 20px);
        }
    }
    
    `],
})

export class TextEditorComponent implements OnInit, AfterViewInit, DCInput, OnDestroy {
    channelsBundle:ChannelsBundle = null;
    title:string = "Текстовый редактор";
    /**
     * Плейлист в текстовом формате.
     */
    playlist:string = "";
    /**
     * Индикатор, указывает, что файл был перемещен на страницу.
     */
    dragEntered = false;
    destroyEmitter = new EventEmitter(null);
    /**
     * Element кнопки Применить. Необходим для установки фокуса
     */
    @ViewChild("applyButton", {static: true}) applyButton:ElementRef;
    /**
     * Отображать ли кнопку объединения плейлистов.
     */
    showJoinButton:boolean = true;
    constructor(private _dialog:DialogService) { }
    ngOnInit(){
        document.addEventListener("dragenter", this.dragenter);
        document.addEventListener("drop", this.drop_ondocument);
        document.addEventListener("dragover", this.dragover);
        document.addEventListener("dragleave", this.dragleave);
    }
    ngAfterViewInit(){
        this.applyButton.nativeElement.focus();
    }
    ngOnDestroy(){
        document.removeEventListener("dragenter", this.dragenter);
        document.removeEventListener("drop", this.drop_ondocument);
        document.removeEventListener("dragover", this.dragover);
        document.removeEventListener("dragleave", this.dragleave);
        this.destroyEmitter.complete();
    }
    /**
     * Преобразует объект с каналами и группами в текстовой формат плейлиста.
     */
    init() {
        this.sort();
        this.playlist = "#EXTM3U";
        this.playlist += this.channelsBundle.EXTM3U_prop ? this.channelsBundle.EXTM3U_prop : " ";
        this.playlist += "\n";
        this.channelsBundle.channels.forEach(channel => {
        this.channelsBundle.groups.find((group)=>{
            if(channel.group_id == group.id && group.id !== null){
                this.playlist += `#EXTINF:-1 `;
                // Группы в формате  group-title=
                this.playlist += !this.channelsBundle.EXTGRP ? ` group-title="${group.name}" ` : "";
                // EPG ID
                this.playlist += channel.tvg_id ? ` tvg-id="${channel.tvg_id}" ` : "";
                // Логотип канала
                this.playlist += channel.icon && (channel.icon.indexOf("http") === 0) ?  ` tvg-logo="${channel.icon}" ` : "";
                // Дополнительные атрибуты для канала.
                this.playlist += channel.additionalAttributes ? " "+channel.additionalAttributes : "";
                // Имя канала
                this.playlist += `,${channel.name}`;
                // Группы в формате #EXTGRP:
                this.playlist += this.channelsBundle.EXTGRP ? `\n#EXTGRP:${group.name}`: "";
                // URL канала
                this.playlist += `\n`+channel.url.trim()+`\n`;
                return true;
            }
        });
        });
        this.playlist += "#EXT-X-ENDLIST";
     }
    /**
     * Функция сортировки, определяется родительским компонентом.
     */
    sort (){ }
    /**
     * Закрытие текстового редактора.
     */
    close(){
        this._dialog.confirm("Закрыть текстовый редактор?",(onOk:boolean)=>{
            if(onOk){
                this.destroyEmitter.emit(null);
            }
        })
    }
    /**
     * Преобразует текст в объект каналов и групп
     */
    parse_playlist_string():{channels:Channel[], groups:ChannelsGroup[], EXTGRP:boolean, EXTM3U_prop:string} | false {
        let channels = [], groups = [], EXTGRP = true, EXTM3U_prop = "";
        const twoStrings = this.playlist.match(/^\s*\#EXTINF:[\s\S]*?^\s*[^#\s][^\r\n]+$/img);
        if(twoStrings != null && twoStrings.length > 0){
            const tmpGroups:string[] = [];
            twoStrings.forEach((value:string)=>{
                let name:any = value.match(/,([^\r\n]+)$/im),
                    tvgId = "", tvgLogo = "", additionalAttributes = "",
                    groupTitle:any = value.match(/#EXTGRP:([^\r\n]+)/i),
                    url:any = value.match(/\n([^\r\n]+$)/i);
                name  = name != null ? name[1] : "Без названия";
                groupTitle  = groupTitle != null ? groupTitle[1] : "Каналы";
                url = url != null ? url[1].trim() : "";
                
                let regexp = RegExp(/\s([\S]+)=['"]([^'"\n]+)['"]/ig);
                let match = [];
                while ((match = regexp.exec(value)) !== null) {
                    if(match[1] == "tvg-id" && match[2]){
                        tvgId = match[2];
                    } else if (match[1] == "tvg-logo" && match[2]){
                        tvgLogo = match[2];
                    } else if(match[1] == "group-title" && match[2]) {
                        groupTitle = match[2];
                        EXTGRP = false;
                    } else {
                        additionalAttributes += match[0];
                    }
                }
                let groupID = tmpGroups.indexOf(groupTitle)
                if(groupID == -1){
                    tmpGroups.push(groupTitle);
                    groupID = tmpGroups.length -1;
                }
                channels.push({name: name, tvg_id: tvgId, icon: tvgLogo, url: url, group_id: groupID, additionalAttributes: additionalAttributes});
            });
            // Приводим группы к необходимому формату.
            tmpGroups.forEach((group, index)=>{
                groups.push({name: group, id: index});
            });
            groups.push({id: null, name: "Корзина"});

            const EXTM3U_prop_match = this.playlist.match(/#EXTM3U([^\r\n]+)/im);
            EXTM3U_prop = EXTM3U_prop_match != null ?  EXTM3U_prop_match[1] : "";

            return {channels: channels,
                    groups: groups,
                    EXTGRP: EXTGRP,
                    EXTM3U_prop: EXTM3U_prop        
            };
        } else {
            this._dialog.alert("К сожалению не удалось распознать формат данного файла!");
            return false;
        }
    }
    /**
     * Кнопка сохранения плейлиста. Преобразует текствовой плейлист в массив каналов и групп
     */
    save(){
        const bundle = this.parse_playlist_string();
        if(bundle) {
            this.channelsBundle.channels = bundle.channels;
            this.channelsBundle.groups = bundle.groups;
            this.channelsBundle.EXTM3U_prop = bundle.EXTM3U_prop;
            this.channelsBundle.EXTGRP = bundle.EXTGRP;
            this.channelsBundle.groupSelected = this.channelsBundle.groups[0];
            this.sort();
            // console.log(this.channelsBundle);
            this.destroyEmitter.emit(null);
        }
    }
    /**
     * Объединение плейлистов
     */
    join(){
        const bundle = this.parse_playlist_string();
        // Определяем максимальное значение ID группы, для добавления новых групп
        let maxIdGroup = 0;
        this.channelsBundle.groups.forEach(group=>{
            maxIdGroup = Math.max(maxIdGroup, Math.floor(group.id));
        })
        if(bundle){
            bundle.channels.forEach(channel=>{
                if(!this.channelsBundle.channels.find(bundleChannel=>{
                    // Если url совпадают, значит канал существует.
                    if(bundleChannel.url.trim() === channel.url.trim()){
                        return true;
                    }
                })) {
                    const groupName = bundle.groups[channel.group_id].name;
                    const group = this.channelsBundle.groups.find(gr=>{
                            if(groupName.trim() === gr.name.trim()){
                                return true;
                            }
                        });
                    if(group){
                        channel.group_id = group.id;
                    } else {
                        maxIdGroup++;
                        // Добавляем группу в предпоследнее место. Так как в конце корзина находится.
                        this.channelsBundle.groups.splice(this.channelsBundle.groups.length-1, 0, {name: groupName, id: maxIdGroup});
                        channel.group_id = maxIdGroup;
                    }
                    this.channelsBundle.channels.push(channel);
                }
            });
            
            this.channelsBundle.groupSelected = this.channelsBundle.groups[0];
            this.sort();
            // Удаляем индикатор загрузки EPG для групп
            this.channelsBundle.groups.forEach((group:ChannelsGroup)=>{
                group.epg = false;
            });
            // console.log(this.channelsBundle);
            this.destroyEmitter.emit(null);
        }
    }
    /**
     * Когда файл бросается на поле ввода .drop-background
     * @param e 
     */
    drop(e:DragEvent){
        if(e.dataTransfer && e.dataTransfer.files.length){
            e.preventDefault();
            const file = e.dataTransfer.files[0],
                reader = new FileReader(),
                loader = document.getElementById("ajaxActivity");
            loader.classList.add("show");
            reader.addEventListener("load",(e)=>{
                this.playlist = reader.result.toString();
            });  
            reader.addEventListener("error", ()=>{
                this._dialog.alert("К сожалению прочитать файл не удалось.");
            });
            reader.addEventListener("loadend", (e)=>{
                loader.classList.remove("show");
            });
            reader.readAsText(file);
        }
    }
    /**
     * Срабатывает, когда файл перемещается на страницу.
     * @param e 
     */
    dragenter(e:DragEvent) {
        e.preventDefault();
        if(!this.dragEntered && e.dataTransfer && e.dataTransfer.types.indexOf("Files")>-1){
            this.dragEntered = true;
            (<HTMLElement>document.getElementById("TextEditorContainer")).classList.add("drop-hover");
        }
    }
    /**
     * Файл бросается в любом месте страницы.
     * @param e 
     */
    drop_ondocument(e:DragEvent) {
        if(this.dragEntered) {
            e.preventDefault();
            this.dragEntered = false;
            (<HTMLElement>document.getElementById("TextEditorContainer")).classList.remove("drop-hover");
        }
    }
    /**
     * Файл перемещают за пределы страницы.
     * @param e 
     */
    dragleave(e:DragEvent){
        if(e.clientX == 0 && e.clientY == 0){ // Определяем, что курсор за пределами страницы, так как событие dreagleave срабатывает всякий раз, когда файл перемещается над разными HTML элементами
            this.dragEntered = false;
            (<HTMLElement>document.getElementById("TextEditorContainer")).classList.remove("drop-hover");
        }
    }
    /**
     * Необходимо для того чтобы работал Drag'nDrop
     */
    dragover(e:MouseEvent) {
        e.preventDefault();
    }
}